import CommonHeader from "../../../components/ui/CommonHeader";
import ContentText from "../../../components/ui/ContentText";
import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Platform from "../../../layouts/web/_components/platform";

export default function AboutUs() {
  return (
    <WebLayout>
      <CommonHeader
        title="আমাদের সম্পর্কে"
        description="বাংলাদেশের দক্ষ জনশক্তির উন্নয়নে প্রতিশ্রুতিবদ্ধ"
      />

      <div className="mini-container !max-w-[800px] pt-28">
        <ContentText
          title="About ManPowerX"
          subTitle="Empowering the Backbone of the Global Economy"
          classNames={{ root: "mb-8", subTitle: "text-theme-primary" }}
        >
          At <span className="text-theme-zinc-700 font-medium">ManPowerX</span>
          , we believe that skilled labor is the most valuable export of
          Bangladesh. We are a mission-driven Learning Management System (LMS)
          specifically engineered to bridge the gap between the untapped
          potential of the Bangladeshi workforce and the rigorous demands of the
          international job market.
          <br />
          <br />
          In an era where infrastructure and industry drive global growth, we
          ensure that every electrician, welder, mason, and technician leaving
          our shores is not just a worker, but a{" "}
          <span className="text-zinc-700 text-base font-medium font-['Roboto'] leading-7">
            certified professional
          </span>
          ready to excel on day one.
        </ContentText>

        <ContentText title="Our Mission">
          To democratize high-quality vocational training. By leveraging
          mobile-first technology, we provide every Bangladeshi citizen
          regardless of their location, the tools to learn a trade, master a
          language, and secure a prosperous future for their families through
          safe and legal overseas employment.
        </ContentText>
        <ContentText title="Our Vision">
          To become the definitive gold standard for manpower training in South
          Asia, transforming the perception of blue-collar labor through digital
          certification, skill-matching, and ethical recruitment preparation.
        </ContentText>
        <ContentText
          title="Why ManPowerX?"
          subTitle="1. Trade-Specific Excellence"
        >
          Our curriculum isn't generic. We offer deep-dive modules into specific
          trades including{" "}
          <span className="text-theme-zinc-700 font-medium">
            Construction, HVAC, Industrial Sewing, Plumbing, and Heavy Machinery
            Operation
          </span>
          , all designed to meet the standards of employers in the Middle East,
          Southeast Asia, and Europe.
        </ContentText>
        <ContentText subTitle="2. Language & Culture Integration">
          Moving to a new country is daunting. Beyond technical skills, we
          provide{" "}
          <span className="text-theme-zinc-700 font-medium">
            functional language training
          </span>{" "}
          (Arabic, Korean, English) and "Culture & Laws" orientations to help
          our learners adapt quickly and stay safe in foreign legal
          environments.
        </ContentText>
        <ContentText subTitle="3. Verification & Trust">
          Every certificate issued on ManPowerX is uniquely ID-tracked. This
          allows international employers and recruitment agencies to verify a
          candidate’s skill level instantly, reducing the risk of "skill fraud"
          and ensuring the right person is in the right job.
        </ContentText>
        <ContentText subTitle="4. Built for the Field">
          We know our users. Our platform is optimized for{" "}
          <span className="text-theme-zinc-700 font-medium">
            low-bandwidth environments
          </span>{" "}
          and rugged mobile devices. With offline viewing capabilities, learning
          can happen anywhere from a rural village in Sylhet to a busy workshop
          in Gazipur.
        </ContentText>
        <ContentText title="Our Impact">
          Since our inception, ManPowerX has been more than just an app. We are
          a catalyst for economic mobility:
          <ul className="mt-3 space-y-3 list-inside list-disc">
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Skill Upliftment:
              </span>{" "}
              Turning unskilled laborers into specialized technicians.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Remittance Growth:
              </span>{" "}
              Higher skills lead to higher wages, directly benefiting the
              Bangladesh economy.
            </li>
            <li>
              <span className="text-theme-zinc-700 font-medium">
                Safety First:
              </span>{" "}
              Our mandatory OHS (Occupational Health and Safety) modules reduce
              workplace accidents for our migrant brothers and sisters.
            </li>
          </ul>
        </ContentText>
        <ContentText title="Join the Movement">
          Whether you are a worker looking to upgrade your life, a trainer
          wanting to share your expertise, or a recruiter seeking the best
          talent Bangladesh has to offer{" "}
          <span className="text-theme-zinc-700 font-medium">
            ManPowerX is your partner in progress.
          </span>
        </ContentText>
      </div>

      <Platform />
      <Footer isPlatform />
    </WebLayout>
  );
}
